import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ContentMaxProgressLearnerQueryVariables = Types.Exact<{
  input: Types.ContentMaxProgressLearnerInput;
}>;


export type ContentMaxProgressLearnerQuery = { contentMaxProgressLearner?: { performance?: { progress: number, user?: { id: string, name?: string | null } | null } | { progress: number, user?: { id: string, name?: string | null } | null } | { progress: number, user?: { id: string, name?: string | null } | null } | { progress: number, user?: { id: string, name?: string | null } | null } | { progress: number, user?: { id: string, name?: string | null } | null } | { progress: number, user?: { id: string, name?: string | null } | null } | { progress: number, user?: { id: string, name?: string | null } | null } | {} | null } | null };


export const ContentMaxProgressLearnerDocument = /*#__PURE__*/ gql`
    query contentMaxProgressLearner($input: ContentMaxProgressLearnerInput!) {
  contentMaxProgressLearner(input: $input) {
    performance {
      ... on CoursePerformanceType {
        progress
        user {
          id
          name
        }
      }
      ... on QuizPerformanceType {
        progress
        user {
          id
          name
        }
      }
      ... on ArticlePerformanceType {
        progress
        user {
          id
          name
        }
      }
      ... on PathPerformanceType {
        progress
        user {
          id
          name
        }
      }
      ... on ScormPerformanceType {
        progress
        user {
          id
          name
        }
      }
      ... on ExternalContentPerformanceType {
        progress
        user {
          id
          name
        }
      }
      ... on TaskPerformanceType {
        progress
        user {
          id
          name
        }
      }
    }
  }
}
    `;

export function useContentMaxProgressLearnerQuery(options: Omit<Urql.UseQueryArgs<ContentMaxProgressLearnerQueryVariables>, 'query'>) {
  return Urql.useQuery<ContentMaxProgressLearnerQuery, ContentMaxProgressLearnerQueryVariables>({ query: ContentMaxProgressLearnerDocument, ...options });
};